/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable class-methods-use-this */

import { AxiosResponse } from 'axios';
import { OAuth2Client } from '@kolorado/oauth';
import { axiosInstance } from "../axios-instance";

class VimsSFTPUser {
  private authClient: OAuth2Client | null;

  private baseUrl: string;

  constructor(authClient: OAuth2Client | null, baseUrl: string) {
    this.authClient = authClient;
    this.baseUrl = baseUrl;
  }

  getDealer(
    input: string,
  ): Promise<AxiosResponse<any>> {
    const accessToken = localStorage.getItem('accessToken');
    let parameters = {};
    if (input.length > 0) {
      parameters = { vimsSftpUserId: input };
    }
    return axiosInstance.get<any>(`${this.baseUrl}/users`, {
      params: parameters,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }

  patchSFTPUser(
    dealerCode: string,
    inputs: any,
  ): Promise<AxiosResponse<any>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.patch<any>(`${this.baseUrl}/users/${dealerCode}`, inputs, {
      headers: {
        'Content-Type': 'application/merge-patch+json',
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }

  createSFTPUser(
    inputs: any,
  ): Promise<AxiosResponse<any>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<any>(`${this.baseUrl}/users/bulkCreate`, inputs, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }
}

export default VimsSFTPUser;
